import { buildDispatchable } from '../../actions/_action-utilities';
import { updateUser, save, togglePasswordChangeModal, toggleShowErrors } from '../../actions/users';
import * as dispatchNavigation from '../../actions/navigation';
import { showFeedback } from '../../actions/ui';
import { commonActions } from '@codametrix/ui-common';
const { FeedbackLevel } = commonActions;
export const mapStateToProps = function(state) {
    const { users, ui, organization } = state;
    let adminTabs = ui.actionGroups.find((actionGroup)=>{
        return actionGroup.key === 'admin';
    })?.options[0].subActions.filter((tab)=>{
        return ui.context.activeContext.resources.find((resource)=>{
            return resource.resourceName === tab.resourceId;
        });
    });
    const ssoConfiguration = organization.activeOrganization?.ssoIndicator && ui.context?.activeContext?.resources?.some((resource)=>{
        return resource.resourceName === 'sso_configuration';
    });
    return {
        ...users,
        auth: state.login.auth,
        showHeader: !(adminTabs?.length > 1),
        ssoConfiguration
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        dispatchNavigation: dispatchNavigation.navExport(dispatch),
        save: async (token, user)=>{
            runDispatchable(()=>{
                return dispatch(save({
                    user,
                    token
                }));
            });
        },
        updateUser: async (token, user)=>{
            runDispatchable(()=>{
                return dispatch(updateUser({
                    user,
                    token
                }));
            });
        },
        togglePasswordModal: (isOpen)=>{
            runDispatchable(()=>{
                return dispatch(togglePasswordChangeModal(isOpen));
            });
        },
        toggleLockModal: (isLocked)=>{
            runDispatchable(()=>{
                return dispatch(showFeedback({
                    id: Date.now(),
                    dismissable: true,
                    message: `This user will be ${isLocked ? 'locked' : 'unlocked'} on save`,
                    meta: {
                        level: FeedbackLevel.WARNING
                    }
                }));
            });
        },
        toggleShowErrors: (errors)=>{
            runDispatchable(()=>{
                return dispatch(toggleShowErrors(errors));
            });
        }
    };
};
